<template>
  <div class="scroll-container">
    <div class="scroll-wrapper">
      <slot></slot>
    </div>
  </div>

</template>

<script>
const delta = 15

export default {
  name: 'scrollBar',
  data() {
    return {
      top: 0
    }
  },
  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta
      const $container = this.$refs.scrollContainer
      const $containerHeight = $container.offsetHeight
      const $wrapper = this.$refs.scrollWrapper
      const $wrapperHeight = $wrapper.offsetHeight
      // this.top=eventDelta
      if (eventDelta > 0) {
        this.top = Math.min(0, this.top + eventDelta)
      } else {
        if ($containerHeight - delta < $wrapperHeight) {
          if (this.top < -($wrapperHeight - $containerHeight + delta)) {
            this.top = this.top
          } else {
            this.top = Math.max(this.top + eventDelta, $containerHeight - $wrapperHeight - delta)
          }
        } else {
          this.top = 0
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../styles/variables.scss';

.sidebar-container .scroll-container {
  position: relative;
  width: 100%;
  height: calc(110% - 200px)!important;
  // background-color: $menuBg;
  overflow: overlay;
  .scroll-wrapper {
    // position: absolute;
     width: 100%!important;
     margin-bottom: 20px;
  }
}
  ::-webkit-scrollbar {
/*隐藏滚轮*/
display: none;
}

/* 移动端：侧边栏滚动容器高度留出顶部 logo，允许内部独立滚动 */
@media screen and (max-width: 768px) {
  .sidebar-container .scroll-container {
    height: calc(100vh - 80px) !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollBar/index.vue